import { JsonObject, JsonProperty } from "json2typescript";
import { TrendItem } from "./TrendItem";
import { PublicationListItem } from "src/models/PublicationListItem";

@JsonObject("Affilitation")
export class Affilitation {
    @JsonProperty("top_level")
    public top_level: string = "" ;
}

export class SourceTrendAggregated {

    @JsonProperty("source_id", String)
    public source_id: string = "";

    @JsonProperty("source_name", String)
    public source_name: string = "";

    @JsonProperty("source_name_abbr", String)
    public source_name_abbr: string = "";

    @JsonProperty("source_count", String)
    public source_count: string = ""

}


export class CoAuthorsAggregated {

    @JsonProperty("author_id", String)
    public author_id: string = "";

    @JsonProperty("first_name", String)
    public first_name: string = "";

    @JsonProperty("first_name", String)
    public last_name: string = "";
    
    @JsonProperty("count", Number)
    public count: number = 0;

    @JsonProperty("UD_flag", Boolean)
    public UD_flag: boolean = false;

    @JsonProperty("affiliation_id", String)
    public affiliation_id: string = "";
}

@JsonObject("BasicDetails")
export class BasicDetails {

    @JsonProperty("first_name", String)
    public first_name: string = ""

    @JsonProperty("last_name", String)
    public last_name: string = ""

    @JsonProperty("affiliation", Affilitation)
    public affiliation: Affilitation = new Affilitation()
   
    @JsonProperty("author_id", String)
    public author_id: string = ""    

    @JsonProperty("h_index", String)
    public h_index: string = "0"

    @JsonProperty("document_count", String)
    public document_count: string = "0"   

    @JsonProperty("cited_by", String)
    public cited_by: string = "0"
}

export class SubjectAreasAggregated {

    @JsonProperty("area_code", String)
    public area_code: string = ""

    @JsonProperty("area_name", String)
    public area_name: string = ""

    @JsonProperty("area_name_abbr", String)
    public area_name_abbr: string = ""

    @JsonProperty("count", Number)
    public count: number = 0
}


@JsonObject("AuthorPublicationCombined")
export class AuthorPublicationCombined {

    @JsonProperty("basic_details", BasicDetails,true)
    public basic_details: BasicDetails = new BasicDetails();

    @JsonProperty("documents_trend", [])
    public documents_trend: TrendItem[] = []

    @JsonProperty("source_trend_aggregated", [])
    public source_trend_aggregated: SourceTrendAggregated[] = []

    @JsonProperty("co_authors_aggregated", [])
    public co_authors_aggregated: CoAuthorsAggregated[] = []

    @JsonProperty("subject_areas_aggregated", [])
    public subject_areas_aggregated: SubjectAreasAggregated[] = []

    @JsonProperty("publications", [])
    public publications: PublicationListItem[] = []

}


// WEBPACK FOOTER //
// ./src/models/AuthorPublicationsCombined.ts